import { AssortGroup } from "../AssortGroup";

export const AssortGroupList: AssortGroup[] = [
  {
    objectDb: 0,
    objectId: 1,
    name: "Popcorn",
    pictureUrl: "https://panel.eaktywni.pl/img/kinoTesty/food/popcorn.png",
  } as AssortGroup,
  {
    objectDb: 0,
    objectId: 2,
    name: "Napoje",
    pictureUrl: "https://panel.eaktywni.pl/img/kinoTesty/food/napoje.png",
  } as AssortGroup,
  {
    objectDb: 0,
    objectId: 3,
    name: "Zestawy",
    pictureUrl: "https://panel.eaktywni.pl/img/kinoTesty/food/zestawy.png",
  } as AssortGroup,
  {
    objectDb: 0,
    objectId: 4,
    name: "Dla dzieci",
    pictureUrl: "https://panel.eaktywni.pl/img/kinoTesty/food/forKids.png",
  } as AssortGroup,
  {
    objectDb: 0,
    objectId: 5,
    name: "Burgery",
    pictureUrl: "https://panel.eaktywni.pl/img/kinoTesty/food/burger.png",
  } as AssortGroup,
  {
    objectDb: 0,
    objectId: 6,
    name: "Sosy",
    pictureUrl: "https://panel.eaktywni.pl/img/kinoTesty/food/sosy.png",
  } as AssortGroup,
  {
    objectDb: 0,
    objectId: 7,
    name: "Frytki",
    pictureUrl: "https://panel.eaktywni.pl/img/kinoTesty/food/frytki.png",
  } as AssortGroup,
];
